import { UnifiedCompareState, CompareListsFromAPI, ProductStub } from './types';
import { Product } from 'common/components/product-card/types';

/**
 * NOTE: Преобразует данные списков сравнения из API в унифицированный формат без дублирования
 */
export const transformCompareListsFromAPI = (apiData: CompareListsFromAPI): UnifiedCompareState => {
  const unifiedData: UnifiedCompareState = {};

  if (!apiData || !Array.isArray(apiData)) {
    return unifiedData;
  }

  apiData.forEach((list) => {
    if (!list?.groupId) {
      return;
    }

    const productsData: Record<string, ProductStub> = {};

    if (list.products && Array.isArray(list.products)) {
      list.products.forEach((productId) => {
        if (typeof productId === 'string' && productId.trim()) {
          productsData[productId] = { productId };
        }
      });
    }

    unifiedData[list.groupId] = {
      name: list.name || '',
      groupId: list.groupId,
      productsData,
      isDataLoaded: false,
      isSyncedWithServer: true,
    };
  });

  return unifiedData;
};

/**
 * NOTE: Преобразует унифицированное состояние обратно в формат API (для обратной совместимости)
 */
export const transformCompareListsToAPI = (unifiedData: UnifiedCompareState): CompareListsFromAPI => {
  return Object.values(unifiedData).map((group) => ({
    name: group.name,
    groupId: group.groupId,
    products: Object.keys(group.productsData), // Извлекаем ID из ключей
  }));
};

/**
 * NOTE: Проверяет, является ли продукт заглушкой (не имеет полных данных)
 */
export const isProductStub = (product: Product | ProductStub): product is ProductStub => {
  if (!product) return true;

  return 'productId' in product && Object.keys(product).length === 1;
};

/**
 * NOTE: Проверяет, является ли продукт полным (с полными данными)
 */
export const isFullProduct = (product: Product | ProductStub): product is Product => {
  return !isProductStub(product);
};
